import React, { FunctionComponent, useState } from "react";
import styles from "./TopBar.module.css";
import { AiFillCaretDown } from "react-icons/ai";
import { AiOutlineSearch } from "react-icons/ai";
import { BsFilter, BsPlus } from "react-icons/bs";
import { FaChevronDown, FaFilter } from "react-icons/fa";

import StatusFilter from "../StatusFilter/StatusFilter";
import Import from "../../Components/Import/Import";
import { BsColumnsGap } from "react-icons/bs";
import { connect, useDispatch } from "react-redux";
import { IoClose } from "react-icons/io5";
import { updateStage } from "../../Redux/actions";
import { useEffect } from "react";
import { correctLeadCount } from "../../Services/organizations";
import DistributionModel from "../../Components/Modals/DistributionModel/DistributionModel";
import { themeColors } from "../../Components/theme";
import { MdDelete } from "react-icons/md";
import { BiExport } from "react-icons/bi";

type props = {
  user: any;
  history: any;
  //button title // some design functions are implemented based on differnet titles, like in API panel
  title: string;
  // button screen path
  path: string;
  onClick?: () => void;
  owner?: boolean;
  changeOwner?: () => void;
  // search value for panels
  onChange?: (text: any) => void;
  // status box
  setStatus?: (status: string) => void;
  // left button text change
  filterText: string;
  // for left most button and add button
  status?: string;
  taskFilter?: boolean;
  projectFilter?: boolean;
  // rightmost table column setter
  setColumnModal?: (data: boolean) => void;
  // setSmsModal?: (data: boolean) => void;
  // left button show and unshow condition
  show: boolean;
  // globally setted user role
  userRole: any;
  // only for leftmost button
  showStatusBox?: boolean;
  // dropdown exports only for contacts and users
  onExport?: () => void;
  onCallLogsImport?: () => void;
  onNotesImport?: () => void;
  onTasksImport?: () => void;
  setBulkEdit?: () => void;
  leadsStage: any;
  // setting fields to view for users with different profile
  setListViewModal?: (data: boolean) => void;
  // in api panel, news panel, to add api
  setApiModal?: (data: boolean) => void;
  setReBookingModel?: (data: boolean) => void;
  setHolidayModel?: (data: boolean) => void;
  // not required, just for status types in left most button
  setApiFilter?: (data: string) => void;
  // not required
  apiFilterData?: string;
  // global state
  organizationId: string;
  deleteSelected?: () => void;
  setLoad?: (data: boolean) => void;
  // to enter lead ids for their state to be changed to fresh
  setChangeStageModal?: (data: boolean) => void;
  // select contact whose leads are to be deleted
  setDeleteRecordsModal?: (data: boolean) => void;
  // in custom button panel in admin panel
  setCustomButtonModal?: (data: boolean) => void;
  theme: any;
  toggleCondition?: any;
  clearFilter?: () => void;
  role?: any;
};

const optionApiDataFilter = [
  { "value": "7", "label": "7 Days" },
  { "value": "30", "label": "30 Days" },
  { "value": "all", "label": "Lifetime" }
];
const TopBar: FunctionComponent<props> = ({
  user,
  history,
  title,
  path,
  onClick,
  owner,
  changeOwner,
  onChange,
  setStatus,
  deleteSelected,
  filterText,
  status,
  taskFilter,
  projectFilter,
  setColumnModal,
  show,
  userRole,
  showStatusBox,
  onExport,
  onCallLogsImport,
  onNotesImport,
  onTasksImport,
  setBulkEdit,
  leadsStage,
  setListViewModal,
  setApiModal,
  setReBookingModel,
  setHolidayModel,
  setApiFilter,
  apiFilterData,
  organizationId,
  setLoad,
  setChangeStageModal,
  setDeleteRecordsModal,
  setCustomButtonModal,
  theme,
  toggleCondition,
  clearFilter,
  role
}) => {
  // left most box expand condition
  const [expand, setExpand] = useState(false);
  // dropdown expand condition
  const [expandImport, setExpandImport] = useState(false);
  // search icon on search bar change to cross on change
  const [value, setValue] = useState("");
  const [showApiFilter, setShowApiFilter] = useState(false);
  //  lead distribution panel open and close
  const [showDistributionModal, setShowDistributionModal] =
    useState(false);
  const dispatcher = useDispatch();
  const [apiFilterSelected, setApiFilterSelected] = useState("7")
  const [openSearchBox, SetOpenSearchBox] = useState(false);
  const onStageChange = (event: any, stage: string) => {
    if (event.target.checked) {
      dispatcher(updateStage({ [stage]: true }));
    } else if (!event.target.checked) {
      if (
        stage !== "FRESH" &&
        stage !== "INTERESTED" &&
        stage !== "CALLBACK"
      ) {
        dispatcher(updateStage({ [stage]: false }));
      }
    }
  };
  useEffect(() => {
    if (toggleCondition) {
      setValue('')
    }
  }, [toggleCondition])

  const apiFilter = (event: any) => {
    setApiFilterSelected(event);
    // console.log("event.target.checked",event.target.checked);
    if (setApiFilter) {
      setApiFilter(event);
    }
    // if (event.target.checked) {
    //   if (setApiFilter) {
    //     setApiFilter(event);
    //   }
    // } else {
    //   if (setApiFilter) {
    //     setApiFilter("");
    //   }
    // }
  };
  // api panel, 7 days , .....
  // const apiFilter = (event: any,filter:string) => {
  //   console.log("event.target.checked",event.target.checked);
  //   console.log("event.target.checked",filter);
  //   if (event.target.checked) {
  //     if (setApiFilter) {
  //       setApiFilter(filter);
  //     }
  //   } else {
  //     if (setApiFilter) {
  //       setApiFilter("");
  //     }
  //   }
  // };

  const textStyles = { color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark }
  return (
    <div className={styles.topBar}>
      {showStatusBox === true && title !== 'Add News Link' && (
        <>
          {userRole !== "Sales" && userRole === 'organization' && (
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                {owner && (<div
                  className={styles.statusBox}
                  style={
                    title === "Add Contacts" ||
                      title === "drilldown"
                      ? { borderWidth: "0px" }
                      : {}
                  }
                >

                  <p
                    className={styles.owner}
                    onClick={changeOwner}
                  >
                    Change Owner
                  </p>
                </div>)}
                {owner && (
                  <div
                    className={styles.statusBox}
                    style={{
                      marginLeft: "10px",
                      borderWidth: "0px",
                    }}
                  >
                    <p
                      className={styles.owner}
                      onClick={setBulkEdit}
                    >
                      Edit Records
                    </p>
                  </div>
                )}
              </div>
            </div>
          )}
        </>
      )}

      {owner && (userRole === 'organization' && (
        <div
          className={styles.statusBox}
          style={{ marginLeft: '10px', borderWidth: '0px' }}
        >
          <h6
            className={styles.owner}
            onClick={() => {
              deleteSelected && deleteSelected();
            }}
          >
            Delete Records
          </h6>
        </div>
      ))}
      {owner && (userRole === 'superAdmin' && (
        <button
          className={
            styles.tabButton +
            ' ' +
            styles.rightRounded + ' ' + styles.leftRounded
          }
          style={{
            background: '#e6e6e6',
            color: '#333',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            padding: '8px 18px',
            fontFamily: "var(--font-family-main)",
            fontSize: "var(--font-size-small)",
            minWidth: 100,
            justifyContent: 'flex-start',
            boxShadow: 'none',
            border: 'none',
            cursor: owner ? 'pointer' : 'not-allowed',
            opacity: owner ? 1 : 0.5,
          }}
          onClick={() => {
            deleteSelected && deleteSelected();
          }}
        >
          <MdDelete size={30} style={{ marginRight: 6, color: '#272944' }} />
          Delete
        </button>
      ))}

      {title === "Add Custom Button" && (
        <button
          style={{ marginLeft: "20px" }}
          className={styles.addBox}
          onClick={() => {
            setCustomButtonModal &&
              setCustomButtonModal(true);
          }}
        >
          Add Custom Buttom
        </button>
      )}

      {userRole !== "oganization" &&
        userRole !== "superAdmin" &&
        title === "Add Contacts" && (
          <>
            <div className={styles.leadContainer}>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>Fresh</p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "FRESH");
                  }}
                  checked={leadsStage.FRESH}
                />
              </div>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>
                  Interested
                </p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "INTERESTED");
                  }}
                  checked={leadsStage.INTERESTED}
                />
              </div>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>Call Back</p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "CALLBACK");
                  }}
                  checked={leadsStage["CALLBACK"]}
                />
              </div>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>Won</p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "WON");
                  }}
                  onClick={() => {
                    onChange && onChange("");
                    setValue("");
                  }}
                  checked={leadsStage.WON}
                />
              </div>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>Lost</p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "LOST");
                  }}
                  onClick={() => {
                    onChange && onChange("");
                    setValue("");
                  }}
                  checked={leadsStage.LOST}
                />
              </div>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>
                  Not Interested
                </p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "NOT INTERESTED");
                  }}
                  onClick={() => {
                    onChange && onChange("");
                    setValue("");
                  }}
                  checked={leadsStage["NOT INTERESTED"]}
                />
              </div>
              <div className={styles.leadBox}>
                <p className={styles.leadText}>
                  Transfer Leads
                </p>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    onStageChange(e, "ALL");
                  }}
                  onClick={() => {
                    onChange && onChange("");
                    setValue("");
                  }}
                  checked={leadsStage["ALL"]}
                />
              </div>
            </div>
          </>
        )}

      <div className={styles.box}>
        {title === "Add Api Data" && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ position: "relative" }}>
              <button
                className={styles.tabButton}
                style={{
                  background: '#e6e6e6',
                  color: '#333',
                  fontWeight: 600,
                  display: 'flex',
                  alignItems: 'center',
                  padding: '8px 18px',
                  fontFamily: "var(--font-family-main)",
                  fontSize: "var(--font-size-small)",
                  minWidth: 50,
                  justifyContent: 'center',
                  boxShadow: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  borderTopLeftRadius: '5px',
                  borderBottomLeftRadius: '5px'
                }}
              >
                <span style={{ flex: 1, textAlign: "left" }}>
                  {optionApiDataFilter.find(opt => opt.value === apiFilterSelected)?.label || "7 Days"}
                </span>
                <AiFillCaretDown size={16} style={{ marginLeft: 8 }} />
                {/* Add select for API filter */}
                <select
                  value={apiFilterSelected}
                  style={{
                    height: "26px",
                    width: "80px",
                    borderRadius: "5px",
                    cursor: "pointer",
                    position: "absolute",
                    top: 0,
                    left: 0,
                    opacity: 0,
                    zIndex: 2
                  }}
                  onChange={(e) => apiFilter(e.target.value)}
                >
                  {optionApiDataFilter.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </button>
            </div>
          </div>
        )}
        {(title === "Add Api" && role !== "Replicate") && (
          <button
            className={
              styles.tabButton +
              ' ' +
              styles.leftRounded
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 120,
              justifyContent: 'flex-start',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: 2
            }}
            onClick={() => {
              setApiModal && setApiModal(true);
            }}
          >
            <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
            Add API
          </button>
        )}
        {user?.profile != "Operation Manager" && title === "Add Re-Booking" && role !== "Admin" && (
          <button
            className={
              styles.tabButton +
              ' ' +
              styles.leftRounded
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 120,
              justifyContent: 'flex-start',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: 2
            }}
            onClick={() => {
              setReBookingModel && setReBookingModel(true);
            }}
          >
            <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
            Add Re-Booking
          </button>
        )}
        {title === "Holiday Configuration" && (
          <button
            className={
              styles.tabButton +
              ' ' +
              styles.leftRounded
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 120,
              justifyContent: 'flex-start',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: 2
            }}
            onClick={() => {
              setHolidayModel && setHolidayModel(true);
            }}
          >
            <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
            Add Holiday Configuration
          </button>
        )}
        {title === "Add Form" && (
          <button
            className={
              styles.tabButton +
              ' ' +
              styles.leftRounded
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 120,
              justifyContent: 'flex-start',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: 2
            }}
            onClick={() => {
              setApiModal && setApiModal(true);
            }}
          >
            <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
            Add Form
          </button>
        )}

        {title === "Add News Link" && (
          <button
            className={
              styles.tabButton +
              ' ' +
              styles.leftRounded
            }
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 120,
              justifyContent: 'flex-start',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginRight: 2
            }}
            onClick={() => {
              setApiModal && setApiModal(true);
            }}
          >
            <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
            Add News Link
          </button>
        )}

        {title !== "Add Task" &&
          title !== "drilldown" &&
          title !== "Add Api" &&
          title !== "Add News Link" &&
          title !== "Add Api Data" &&
          title !== "Add Form" &&
          title !== "Add Custom Button" &&
          title !== "All User List" &&
          title !== "View News" &&
          title !== "Lead Distribution" &&
          title !== "Holiday Configuration" &&
          title !== "Add Re-Booking" &&
          title !== "WhatsApp" &&
          (
            <button
              className={
                styles.tabButton +
                ' ' +
                styles.leftRounded
              }
              style={{
                background: '#e6e6e6',
                color: '#333',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                padding: '8px 18px',
                fontFamily: "var(--font-family-main)",
                fontSize: "var(--font-size-small)",
                minWidth: 120,
                justifyContent: 'flex-start',
                boxShadow: 'none',
                border: 'none',
                cursor: 'pointer',
                marginRight: title === "Coupon" || title === "Add Form" || title === "Add Headers" ? 2 : 0
              }}
              onClick={() => {
                title === "Lead Distribution"
                  ? setShowDistributionModal(true)
                  : history.push(path);
              }}
            >
              <BsPlus size={30} style={{ marginRight: 6, color: '#272944' }} />
              {title}
            </button>
          )}

        {showDistributionModal && (
          <DistributionModel
            open={showDistributionModal}
            organization_id={user.organization_id}
            close={() => {
              setShowDistributionModal(false);
            }}
          />
        )}
        {((title === "Add Organization" || title === "All User List") && role === "Admin") && (
          <div className={styles.refreshIcon}>
            <button
              className={styles.tabButton}
              style={{
                background: '#e6e6e6',
                color: '#333',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                padding: '8px 18px',
                fontFamily: "var(--font-family-main)",
                fontSize: "var(--font-size-small)",
                minWidth: 50,
                justifyContent: 'center',
                boxShadow: 'none',
                border: 'none',
                cursor: 'pointer'
              }}
              onClick={onExport}
            >
              <BiExport size={30} style={{ marginRight: 6, color: '#272944' }} />
              Export
            </button>
          </div>
        )}

        {show === true && title !== "drilldown" && title !== "Holiday Configuration" && title !== "Add News Link" &&  title !== "WhatsApp" && (
          <>
            {(userRole === "Lead Manager" ||
              userRole === "organization" ||
              userRole === "Team Lead") && (
                <div className={styles.refreshIcon}>
                  <button
                    className={styles.tabButton}
                    style={{
                      background: '#e6e6e6',
                      color: '#333',
                      fontWeight: 600,
                      display: 'flex',
                      alignItems: 'center',
                      padding: '8px 18px',
                      fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)",
                      minWidth: 50,
                      justifyContent: 'center',
                      boxShadow: 'none',
                      border: 'none',
                      cursor: 'pointer'
                    }}
                    onClick={() => {
                      setExpandImport(!expandImport);
                    }}
                  >
                    <FaChevronDown size={30} style={{ marginRight: 6, color: '#272944' }} />
                    Import/Export
                  </button>
                  {expandImport === true && (
                    <div
                      style={{
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '37px',
                      }}
                    >
                      <Import
                        onClick={onClick}
                        setExpandImport={(data) =>
                          setExpandImport(data)
                        }
                        onExport={onExport}
                        expand={expandImport}
                        close={() => setExpandImport(false)}
                        onCallLogsImport={onCallLogsImport}
                        onNotesImport={onNotesImport}
                        onTasksImport={onTasksImport}
                      />
                    </div>
                  )}
                </div>
              )}
          </>
        )}
        {title !== "Add Custom Button" && (
          <div className={styles.columnManage}>
            <button
              className={
                styles.tabButton +
                ' ' +
                (title === 'View News' || title === "Lead Distribution" ? styles.leftRounded : '') +
                ' ' +
                (title === 'Lead Distribution' ? styles.rightRounded : '')
              }
              style={{
                background: '#e6e6e6',
                color: '#333',
                fontWeight: 600,
                display: 'flex',
                alignItems: 'center',
                padding: '8px 18px',
                fontFamily: "var(--font-family-main)",
                fontSize: "var(--font-size-small)",
                minWidth: 50,
                justifyContent: 'center',
                boxShadow: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
              onClick={() => {
                setColumnModal && setColumnModal(true);
              }}
            >
              <BsColumnsGap size={20} style={{ marginRight: 6, color: '#272944' }} />
              Column Manager
            </button>
          </div>
        )}
        {/* clear filter */}
        <div className={styles.columnManage}>
          <button
            className={styles.tabButton}
            style={{
              background: '#e6e6e6',
              color: '#333',
              fontWeight: 600,
              display: 'flex',
              alignItems: 'center',
              padding: '8px 18px',
              fontFamily: "var(--font-family-main)",
              fontSize: "var(--font-size-small)",
              minWidth: 50,
              justifyContent: 'center',
              boxShadow: 'none',
              border: 'none',
              cursor: 'pointer',
              marginLeft: 2
            }}
            onClick={() => {
              clearFilter && clearFilter();
            }}
          >
            <BsFilter size={24} style={{ marginRight: 6, color: '#272944' }} />
            Clear Filter
          </button>
        </div>
        {/* clear filter */}
        {/* search box */}
        {title !== "drilldown" &&
          title !== "Lead Distribution" &&
          title !== "Add Custom Button" &&
          title !== "Add Headers" && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', minWidth: 160, marginLeft: 2 }}>
                <div
                  className={styles.rightRounded}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    width: 160,
                    overflow: 'hidden',
                    border: '1px solid #e0e0e0',
                    background: '#e6e6e6',
                    color: '#333',
                    height: 34
                  }}

                >
                  <input
                    className={styles.searchText}
                    style={{
                      border: 'none',
                      outline: 'none',
                      padding: '0 12px',
                      fontFamily: "var(--font-family-main)",
                      fontSize: "var(--font-size-small)",
                      flex: 1,
                      background: 'transparent',
                      color: '#272944',
                      height: '100%'
                    }}
                    placeholder="Search..."
                    value={value}
                    onChange={(val) => {
                      onChange && onChange(val.target.value);
                      setValue(val.target.value);
                    }}
                  />
                </div>
              </div>
            </>
          )}
        {/* search box */}
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    userRole: state.user.role,
    leadsStage: state.leadsStage.stage,
    organizationId: state.organization.id,
    theme: state.theme.isLightMode
  };
};

export default connect(mapStateToProps)(TopBar);